//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import { conversion, addZero, formatDate } from "@/tool";
export default {
  name: "listItem",
  data() {
    return {
      multiplePeopleCase_list_item: {},
    };
  },
  watch: {
    item: {
      handler(val) {
        this.multiplePeopleCase_list_item = val;

        let obj = {
          string: "YYYY-MM-DD hh:mm:ss",
          date: new Date(this.multiplePeopleCase_list_item.endTime),
        };
        this.multiplePeopleCase_list_item.endTimeShow = formatDate(obj);
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    currentTab: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["user"]),
    curCases() {
      if (!this.multiplePeopleCase_list_item.cases) {
        return [];
      }
      return this.multiplePeopleCase_list_item.cases.map((item) => item);
    },
    curUserRealId() {
      return parseInt(this.user.id );
    },
  },
  filters: {
    conversion,
    addZero,
    formatDate,
  },
  mounted() {
  },
  methods: {
    //点击箱子事件
    openCaseDetail(item) {
      this.$emit("handleCase", item);
    },
    handleShowmultiplePeopleCaseDetail(item) {
      this.$router.push({
        name: "multiplePeopleCaseDetail",
        params: {
          id: item.id,
          isAutoOpenAward: item.status == "4" ? true : false,
        },
        query: this.$route.query || {},
      });
    },
  },
};
